import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("tt-cookie-consent");
    if (!accepted) {
      const t = setTimeout(() => setShow(true), 1400);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (val) => {
    localStorage.setItem("tt-cookie-consent", val);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: "spring", stiffness: 220, damping: 24 }}
          className="fixed bottom-24 sm:bottom-4 inset-x-4 z-[70] mx-auto max-w-2xl"
          data-testid="cookie-consent"
        >
          <div className="flex flex-col items-center gap-4 rounded-2xl glass-strong p-5 sm:flex-row">
            <div className="flex items-start gap-3">
              <Cookie size={22} className="mt-0.5 flex-shrink-0 text-tt-gold" />
              <p className="text-sm leading-relaxed text-tt-silver/70">
                We use cookies to enhance your experience and analyze performance. By continuing, you
                agree to our use of cookies.
              </p>
            </div>
            <div className="flex w-full gap-2 sm:w-auto">
              <button
                onClick={() => decide("declined")}
                className="flex-1 rounded-full border border-white/10 px-4 py-2 font-grotesk text-xs text-tt-silver/70 transition-colors hover:text-tt-chrome sm:flex-none"
                data-testid="cookie-decline"
              >
                Decline
              </button>
              <button
                onClick={() => decide("accepted")}
                className="flex-1 rounded-full bg-tt-gold px-5 py-2 font-grotesk text-xs font-semibold text-tt-black transition-colors hover:bg-tt-goldsoft sm:flex-none"
                data-testid="cookie-accept"
              >
                Accept
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
